module.exports = __webpack_public_path__ + "fonts/Adelle_ExtraBold.c499c2b5.woff";